import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, BadgeListSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const styles = StyleSheet.create({
    page: { padding: 0, fontSize: 10, fontFamily: 'Helvetica' },
    banner: { backgroundColor: '#f7f7fb', padding: 24, alignItems: 'center' },
    name: { fontSize: 20, fontWeight: 'bold', textAlign: 'center' },
    title: { fontSize: 12, textAlign: 'center', marginBottom: 8 },
    body: { padding: 24 },
    topRow: { flexDirection: 'row', marginBottom: 10 },
    topCol: { flex: 1, paddingRight: 10 },
});

function Template3Pdf(props) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        linkedinURL, twitterURL, githubURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <View style={styles.banner}>
                    <Text style={styles.name}>{name}</Text>
                    <Text style={styles.title}>{title}</Text>
                </View>
                <View style={styles.body}>
                    <View style={styles.topRow}>
                        <View style={styles.topCol}><AboutSection about={about} /></View>
                        <View style={styles.topCol}><ContactSection email={email} phone={phone} address={address} /></View>
                        <View style={styles.topCol}><SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} githubURL={githubURL} websiteURL={websiteURL} showSocial={showSocial} /></View>
                    </View>
                    <BadgeListSection title="Professional Skills" items={technicalSkills} />
                    <BadgeListSection title="Soft Skills" items={softSkills} />
                    <BadgeListSection title="Languages Known" items={languages} />
                    <ExperienceSection jobData={jobData} />
                    <EducationSection educationData={educationData} />
                    <ReferencesSection referenceData={referenceData} />
                </View>
            </Page>
        </Document>
    );
}

export default Template3Pdf;